import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectAssessment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.62284 1.63527C9.42742 1.54613 9.21513 1.5 9.00034 1.5C8.78555 1.5 8.57326 1.54613 8.37784 1.63527L1.95034 4.56027C1.81725 4.61895 1.7041 4.71507 1.62466 4.83691C1.54522 4.95875 1.50293 5.10107 1.50293 5.24652C1.50293 5.39197 1.54522 5.53428 1.62466 5.65613C1.7041 5.77797 1.81725 5.87408 1.95034 5.93277L8.38534 8.86527C8.58076 8.95441 8.79305 9.00054 9.00784 9.00054C9.22263 9.00054 9.43492 8.95441 9.63034 8.86527L16.0653 5.94027C16.1984 5.88158 16.3116 5.78547 16.391 5.66363C16.4705 5.54178 16.5127 5.39947 16.5127 5.25402C16.5127 5.10857 16.4705 4.96625 16.391 4.84441C16.3116 4.72257 16.1984 4.62645 16.0653 4.56777L9.62284 1.63527Z",
			stroke: "#6A7282",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 9C1.49965 9.14345 1.54044 9.28399 1.61754 9.40496C1.69464 9.52593 1.80482 9.62225 1.935 9.6825L8.385 12.615C8.5794 12.703 8.79035 12.7486 9.00375 12.7486C9.21715 12.7486 9.4281 12.703 9.6225 12.615L16.0575 9.69C16.1903 9.63033 16.3028 9.53332 16.3814 9.4108C16.4599 9.28828 16.5012 9.14555 16.5 9",
			stroke: "#6A7282",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 12.75C1.49965 12.8935 1.54044 13.034 1.61754 13.155C1.69464 13.2759 1.80482 13.3723 1.935 13.4325L8.385 16.365C8.5794 16.453 8.79035 16.4986 9.00375 16.4986C9.21715 16.4986 9.4281 16.453 9.6225 16.365L16.0575 13.44C16.1903 13.3803 16.3028 13.2833 16.3814 13.1608C16.4599 13.0383 16.5012 12.8955 16.5 12.75",
			stroke: "#6A7282",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSelectAssessment;
